import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  savePhaseItem,
} from 'actionCreators/phase_items';
import LineItemTable from 'components/LineItemTable';
import WarehousePadTableRow from './warehousePadTableRow';
import phaseLineItemShape from 'types/lineItemPropType';

const WarehousePadTable = ({ lineItems, editable, handleSave }) => {
  const hasData = (lineItems || []).length > 0;
  return (
    <LineItemTable title="Warehouse Pads" readOnly={!hasData}>
      {hasData && lineItems.map(item =>
        <WarehousePadTableRow
          key={item.id}
          onSave={handleSave}
          lineItem={item}
          readOnly={!editable}
        />,
      )}
    </LineItemTable>
  );
};

WarehousePadTable.defaultProps = {
  lineItems: [],
};

WarehousePadTable.propTypes = {
  phaseId: PropTypes.string,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape(phaseLineItemShape),
  ),
  savePhaseItem: PropTypes.func,
  handleSave: PropTypes.func,
  editable: PropTypes.bool.isRequired,
};

export default connect(null,
  {
    savePhaseItem,
  })(WarehousePadTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehousePadTable.jsx